import { z } from "zod";

export const signupSchema = z.object({
  username: z.string().min(1, "Username is required"),
  email: z
    .string()
    .email("Invalid email address")
    .max(255, "Email cannot exceed 255 characters")
    .trim()
    .toLowerCase()
    .refine(
      (val) => {
        const [, domain] = val.split("@");
        return domain && !["example.com", "test.com"].includes(domain);
      },
      {
        message: "Email domain is not allowed",
      },
    ),

  password: z
    .string()
    .min(6, "Password must be at least 6 characters")
    .max(30, "Password cannot exceed 30 characters")
    .regex(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/,
      "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character",
    ),
  role: z.enum(["candidate", "recruiter", "smallbiz_owner", "nonprofit"], {
    errorMap: () => ({ message: "Please select a valid role" }),
  }),
});
